module.exports = __webpack_public_path__ + "img/wheel_bg1.4228a4df.png";